const search = {
    untitledResult: 'タイトルなし',
    noFacetOptions: '該当する選択肢がありません',
    noResultsHint: 'キーワードを変えるか、フィルターを解除してお試しください。',
    types: {
      basic: 'キーワード検索',
      basicHint: '語句をそのまま照合します',
      semantic: '意味検索',
      semanticHint: '言い回しが違っても意味で照合します',
      exact: '完全一致',
      exactHint: '入力どおりに一致するものだけを返します',
    },
    sort: {
      relevance: '関連度',
      date: '登録日',
      title: 'タイトル',
    },
    title: '検索',
    searchDocuments: 'ドキュメントを検索',
    advancedSearch: '詳細検索',
    searchResults: '検索結果',
    noResults: '検索結果がありません',
    errorTitle: '検索エラー',
    searchIn: '検索対象',
    matchType: 'マッチタイプ',
    exactMatch: '完全一致',
    fuzzyMatch: 'あいまい検索',
    suggestions: '検索候補',
    relatedDocuments: '関連ドキュメント',
    searchHistory: '検索履歴',
    recentSearches: '最近の検索',
    searchError: '検索エラー',
    searchFailed: '検索に失敗しました',
    savedSearches: '保存された検索',
    // Search Page specific
    searchPlaceholder: 'ドキュメント、レポート、プレゼンテーションを検索...',
    filters: 'フィルター',
    searchType: '検索タイプ',
    searchTypes: {
      basic: '基本検索',
      semantic: 'セマンティック検索',
      exact: '完全一致',
    },
    sortOptions: '並び替えオプション',
    sortBy: '並び替え',
    sortValues: {
      relevance: '関連度',
      title: 'タイトル',
    },
    order: '順序',
    sortOrder: {
      desc: '降順',
      asc: '昇順',
    },
    active: '有効',
    activeFilters: '有効なフィルター',
    noDocumentsMatch: '「{{query}}」に一致するドキュメントはありません',
    adjustTermsOrFilters: '検索語句またはフィルターを調整してください',
    resultsSummary: '{{total}}件の結果',
    resultsSummaryForQuery: '「{{query}}」の結果 {{total}}件',
    searchTime: '({{time}}秒)',
  };

export default search;
